
import GridSync from '@/ui-kit/components/grid/sync';
import { GutterProperty } from '@/ui-kit/components/gutter/enums';
import { GridCellCommonPropsType } from '@/ui-kit/components/grid/enums';
import { StylePositionType, StyleSizeType } from '@/ui-kit/styles/enums';
import SoldDataTableAddressCell from './address-cell';
import SoldDataTableTransactionsCell from './transactions-cell';
import SoldDataTableVisibilityCell from './visibility-cell';
import {
  SOLD_DATA_LISTING_TABLE_COMMON_COLUMNS,
  ADMIN_SOLD_DATA_LISTING_TABLE_COLUMNS,
  SOLD_DATA_DEFAULT_TABLE_SIZES,
} from './constants';
import SoldDataTableRowsProps from './mixins/SoldDataTableRowsProps';
import { SoldDataTableCustomColumnKey, SoldDataTableEventType } from './enums';
import SoldDataTableHeader from './header';

export default {
  name: 'SoldDataTable',
  components: {
    GridSync,
    SoldDataTableAddressCell,
    SoldDataTableVisibilityCell,
    SoldDataTableTransactionsCell,
    SoldDataTableHeader,
  },
  mixins: [SoldDataTableRowsProps],
  data() {
    return {
      SoldDataTableEventType,
      GutterProperty,
      StylePositionType,
      StyleSizeType,
      SoldDataTableCustomColumnKey,
      SOLD_DATA_DEFAULT_TABLE_SIZES,
    };
  },
  computed: {
    user() {
      return this.$store.state.user.userData;
    },
    isAdmin() {
      return !!this.user.roles?.admin;
    },
    tableColumns() {
      return this.isAdmin
        ? ADMIN_SOLD_DATA_LISTING_TABLE_COLUMNS
        : SOLD_DATA_LISTING_TABLE_COMMON_COLUMNS;
    },
  },
  methods: {
    emitTransactionChange(addressId, currentTransactionIndex) {
      const row = this.findRowByAddressId(addressId);
      const indexOfRow = this.tableRows.indexOf(row);
      const newRow = {
        ...row[SoldDataTableCustomColumnKey.Transactions].value.rows[currentTransactionIndex],
        [SoldDataTableCustomColumnKey.Transactions]: row[SoldDataTableCustomColumnKey.Transactions],
      };

      this.$emit(SoldDataTableEventType.TransactionChange, {
        row: newRow,
        index: indexOfRow,
      });
    },
    findRowByAddressId(addressId) {
      return this.tableRows.find((row) => (
        row[SoldDataTableCustomColumnKey.Transactions].value.addressId === addressId
      ));
    },
    getTransactionsData(customCellData) {
      const { row } = customCellData[SoldDataTableCustomColumnKey.Transactions];

      return row[SoldDataTableCustomColumnKey.Transactions][GridCellCommonPropsType.Value];
    },
    getAddressData(customCellData) {
      const { row } = customCellData[SoldDataTableCustomColumnKey.Address];

      return row[SoldDataTableCustomColumnKey.Address][GridCellCommonPropsType.Value];
    },
    getVisibilityData(customCellData) {
      const { row } = customCellData[SoldDataTableCustomColumnKey.Visibility];

      return row[SoldDataTableCustomColumnKey.Visibility][GridCellCommonPropsType.Value];
    },
    handleTransactionChange({ addressId, index }) {
      this.emitTransactionChange(addressId, index);
    },
    handleToggleListingVisibility(listing) {
      this.$emit(SoldDataTableEventType.ToggleVisibility, listing);
    },
  },
};

